const CHECKOUT_RETURN_QUERY_KEYS = [
  'payment',
  'payment_intent',
  'payment_intent_client_secret',
  'purchase_type',
  'redirect_status',
  'wallet_checkout',
  'ad_wallet_checkout',
  'session_id',
  'subscription',
];

export const isNativeAppRuntime = (): boolean => {
  if (typeof window === 'undefined') return false;

  const searchParams = new URLSearchParams(window.location.search);
  return (
    searchParams.get('app') === '1' ||
    /Bid4BabesApp\/(Android|iOS)/i.test(window.navigator.userAgent)
  );
};

export const getCheckoutReturnPath = (fallbackPath = '/'): string => {
  if (typeof window === 'undefined') return fallbackPath;

  const params = new URLSearchParams(window.location.search);
  CHECKOUT_RETURN_QUERY_KEYS.forEach((key) => params.delete(key));

  if (isNativeAppRuntime()) {
    params.set('app', '1');
  }

  const query = params.toString();
  return `${window.location.pathname || fallbackPath}${query ? `?${query}` : ''}`;
};

export const buildStripeReturnUrl = (
  pathname: string,
  params: Record<string, string | number | null | undefined> = {}
): string => {
  const url = new URL(pathname, window.location.origin);

  if (isNativeAppRuntime()) {
    url.searchParams.set('app', '1');
  }

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, String(value));
    }
  });

  return url.toString();
};
